module.exports = __webpack_public_path__ + "static/acumulation-step1-2ebe93bbb77b55f5ad9833b06dfcd2c5.png";